export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13962.9477d87f.jpg";